module.exports = __webpack_public_path__ + "img/sea-6.86cab6b1.jpg";